module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "overline",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-5"
  }, _vm._l((_vm.options), function(option) {
    return _c('v-btn', {
      key: option.id,
      staticClass: "mb-3",
      staticStyle: {
        "border-radius": "25px"
      },
      attrs: {
        "outline": "",
        "rounded": "",
        "x-large": "",
        "block": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.setSelected(option)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.text) + "\n    ")])
  }), 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [(_vm.selected && _vm.selected.prompt) ? _c('v-card', [(_vm.selected.prompt.title) ? _c('v-card-title', {
    staticClass: "overline",
    domProps: {
      "textContent": _vm._s(_vm.selected.prompt.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selected.prompt.description) ? _c('v-card-text', {
    domProps: {
      "textContent": _vm._s(_vm.selected.prompt.description)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selected.prompt) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.dialog = false;
        _vm.$emit("selected", _vm.selected)
      }
    }
  }, [_vm._v(_vm._s(_vm.selected.prompt.done || "Got it"))])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c5b676a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wizards/screens/Decision.vue
// module id = 1480
// module chunks = 9